var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrakstarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 111,
    viewBox: "0 0 110 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.7897 55.7997C77.6795 61.9854 88.4681 65.6238 100.095 65.6238C80.6253 65.6238 64.7859 81.4632 64.7859 100.933C64.7859 89.306 61.1448 78.5174 54.9618 69.6276C58.7128 64.2388 63.4009 59.5507 68.7897 55.7997ZM41.1338 55.7997C32.2441 61.9854 21.4554 65.6238 9.82861 65.6238C29.2982 65.6238 45.1377 81.4632 45.1377 100.933C45.1377 89.306 48.7788 78.5174 54.9618 69.6276C51.2107 64.2388 46.5227 59.5507 41.1338 55.7997ZM54.9618 41.9717C48.776 33.0819 45.1377 22.2933 45.1377 10.6665C45.1377 30.1361 29.2982 45.9756 9.82861 45.9756C21.4554 45.9756 32.2441 49.6139 41.1338 55.7997C46.5227 52.0486 51.2107 47.3605 54.9618 41.9717ZM68.7897 55.7997C77.6795 49.6139 88.4681 45.9756 100.095 45.9756C80.6253 45.9756 64.7859 30.1361 64.7859 10.6665C64.7859 22.2933 61.1448 33.0819 54.9618 41.9717C58.7128 47.3605 63.4009 52.0486 68.7897 55.7997Z",
    fill: "#FAB005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8241 45.9757C4.39955 45.9757 0 50.3725 0 55.7998C0 61.2271 4.39955 65.6239 9.8241 65.6239C21.4509 65.6239 32.2395 61.9856 41.1293 55.7998C32.2395 49.6141 21.4536 45.9757 9.8241 45.9757Z",
    fill: "#FAB005"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1359 100.936C45.1359 106.36 49.5327 110.76 54.96 110.76C60.3873 110.76 64.7841 106.36 64.7841 100.936C64.7841 89.309 61.143 78.5203 54.96 69.6305C48.7743 78.5203 45.1359 89.3062 45.1359 100.936Z",
    fill: "#FAB005"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.096 45.9757C88.4691 45.9757 77.6805 49.6141 68.7907 55.7998C77.6805 61.9856 88.4691 65.6239 100.096 65.6239C105.52 65.6239 109.92 61.2271 109.92 55.7998C109.92 50.3725 105.52 45.9757 100.096 45.9757Z",
    fill: "#FAB005"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7841 10.6639C64.7841 5.23939 60.3873 0.839844 54.96 0.839844C49.5327 0.839844 45.1359 5.23939 45.1359 10.6639C45.1359 22.2907 48.777 33.0794 54.96 41.9692C61.1457 33.0794 64.7841 22.2935 64.7841 10.6639Z",
    fill: "#FAB005"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrakstarLogo);
export default __webpack_public_path__ + "static/media/trakstarLogo.6725b1f650929f2ad462813766f61ebe.svg";
export { ForwardRef as ReactComponent };